import Switcher from './switcher-component';

import './switcher.scss';

const MODULE_NAME = 'app.common.widgets.switcher';
const module = angular.module(MODULE_NAME, [])
    .directive(Switcher.DIRECTIVE_NAME, Switcher);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/switcher/switcher-module.js